import React, { useEffect, useRef } from "react";
import { useForm, useFormState } from "react-final-form";

import DynamicRadioInput from "./DynamicRadioInput";

const UNEMPLOYED_OCCUPATION_IDS = [1, 3];

const OccupationDurationInput = (props) => {
  const { values } = useFormState({ subscription: { values: true } });
  const form = useForm();
  const occupationId = values?.occupation_id;
  const didMount = useRef(false);
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    if (UNEMPLOYED_OCCUPATION_IDS.indexOf(occupationId) === -1) {
      form.change("occupation_duration_id", 4); // Non disponibile
    } else {
      form.change("occupation_duration_id", null); // Il primo disponibile.
    }
  }, [form, occupationId]);

  if (UNEMPLOYED_OCCUPATION_IDS.indexOf(occupationId) === -1) {
    return null;
  }

  return <DynamicRadioInput {...props} filter={{ valid: true }} />;
};

export default OccupationDurationInput;
